( function ($) {
    var player = {};
    var slideshow_container = $('.slideshow_container');


    function play_video(counter) {
        if (typeof player[counter]  === 'undefined') {
            window.console && console.log('Player not initialized yet');
            return;
        }
        player[counter].play();
        displayVideoWrapper();
        var video_height = $( player[counter].elements.container).height();
        slideshow_container.css({
            height: video_height,
            minHeight: 0
        });
    }

    function displayVideoWrapper() {
        slideshow_container.addClass('playing');
    }

    function restoreSlideshow() {
        slideshow_container.removeClass('playing');
        slideshow_container.removeAttr('style');
    }

    function display_play_button(jQEl) {
        jQEl.fadeIn();
    }

    function initVideoPlayer(player_wrap) {
        var control_stop = $('.slideshow_container .controls .stop');
        var control_mute = $('.slideshow_container .controls .mute');
        var container_selector = '#'+player_wrap.attr('id');
        var counter =  player_wrap.data('player-counter');

        var video_id = player_wrap.data('plyr-embed-id');

        // player_container.attr('data-plyr-embed-id', id);
        player[counter] = new Plyr(container_selector, {
            controls: [
                'play-large',
                'play',
                'progress',
                'current-time',
                'mute',
                'volume',
                'captions',
                'airplay',
                'fullscreen'
            ],
            quality: {
                default: 'auto',
            },
            storage: {
                enabled: true,
                key: 'ply_' + counter
            },
            volume: 0.9
        });
        player[counter].on('ready', function() {
            console.log('Video ready', counter, video_id);
            display_play_button($('.slideshow').find('.video_play[data-video-counter="' + counter + '"]'));
            $(window).trigger('video_ready_' + counter);
            $(window).on('video_autoplay_' + counter, function () {
                if(! navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
                    player[counter].volume = 0;
                    $('.slideshow').find('.video_play[data-video-counter="' + counter + '"]').trigger('click');
                }
            });
        });

        player[counter].on('statechange', function(e) {
            if (e.detail.code === 0) {
                restoreSlideshow();
            }
        });

        control_stop.click(function () {
            player[counter].stop();
            restoreSlideshow();
        });

        control_mute.click(function () {
            var btn = $(this);
            if (btn.hasClass('mute')) {
                btn.attr('aria-label',btn.data('unmute-arialabel'));
                player[counter].volume=0;
                btn.removeClass('mute');
                btn.addClass('unmute');
            } else {
                btn.attr('aria-label',btn.data('mute-arialabel'));
                player[counter].volume=0.9;
                btn.removeClass('unmute');
                btn.addClass('mute');
            }
        });
    }

    $(document).ready(function () {
        doSlideshow();
    });
    
    function lazySlide(array, index) {
        var sources = $(array[index]).find('source');
        var img = $(array[index]).find('img');
        var src = img.attr('data-src');

        sources.each(function () {
            var source = $(this).attr('data-srcset');
            $(this).attr('srcset', source);
            $(this).attr('data-processed', 'true');
            $(this).removeAttr('data-srcset');

        });
        img.attr('src', src);
        img.attr('data-processed', 'true');
        img.removeAttr('data-src');
    }

    function doSlideshow() {
        var wrap = $('.slideshow');
        var multiple_post = $('.multiple_post');
        var video_wrap = $('.ss_video_wrapper');
        if (wrap.length > 0) {

            var customPagingVariable = function (slider, i) {
                // var thumb = $(slider.$slides[i]).data();
                i = i + 1;
                if (i.toString().length < 2) {
                    i = "0" + i;
                }
                return '<a class="dot">' + i + '</a>';
            }

            //LAZY LOADING (before carousel is loaded)
            wrap.on("init", function () {

                //load 1st, 2nd and last slide
                var slides = wrap.find('.slide');

                if(slides.length <= 1){
                    dots = false
                }
                var slidesLoaded = [slides[0], slides[1], slides[ss_lenght - 1]];

                //items index change based on animation kind (0 to n-1 for fade, 1 to n for slide)
                if (animation === false) {
                    slidesLoaded = [slides[1], slides[2], slides[ss_lenght]];
                }
                slides.each(function (index) {
                    lazySlide(slidesLoaded, index);
                })
            });

            //slideshow setup
            wrap.slick({
                rows: 0,
                fade: animation,
                pauseOnHover: false,
                pauseOnFocus: false,
                autoplay: autoplay,
                arrows: arrows,
                dots: dots,
                infinite: true,
                customPaging: customPagingVariable,
                autoplaySpeed: autoplaySpeed,
                speed: animationSpeed,
                nextArrow: wrap.parent().find('.next'),
                prevArrow: wrap.parent().find('.prev'),
                appendDots: wrap.parent().find('.pager_slider'),
                rtl: $('html').attr('dir') === 'rtl'
            });
        }
        if(multiple_post.length > 0 && multiple_post.find('.highlighted_post').length > 1){
            multiple_post.slick({
                rows: 0,
                fade: animation,
                slide: '.highlighted_post',
                pauseOnHover: false,
                pauseOnFocus: false,
                autoplay: autoplay,
                arrows: arrows,
                dots: dots,
                infinite: true,
                autoplaySpeed: autoplaySpeed,
                speed: animationSpeed,
                nextArrow: multiple_post.parent().find('.next'),
                prevArrow: multiple_post.parent().find('.prev'),
                appendDots: multiple_post.parent().find('.pager_slider'),
                rtl: $('html').attr('dir') === 'rtl'
            });
        }

        //LAZY LOADING (after carousel is loaded)
        //load 1st, 2nd and last clone
        var clones = wrap.find('.slick-cloned');
        var clonesLoaded = [clones[0], clones[1], clones[ss_lenght - 1]];

        //items index change based on animation kind (0 to n-1 for fade, -1 to n-2 for slide)
        if (animation === false) {
            clonesLoaded = [clones[0], clones[1], clones[2]];
        }
        clones.each(function (index) {
            lazySlide(clonesLoaded, index);
        });

        wrap.on("afterChange", function (e, slick) {
            var slides = $.merge(slick.$slides, clones);

            //load next slide + 1
            var index = slick.currentSlide + 1;

            lazySlide(slides, index);

            //load previous slide - 1
            if (slick.currentSlide === 0) {
                index = ss_lenght - 1;
            } else {
                index = slick.currentSlide - 1;
            }
            lazySlide(slides, index);

            //load current slide if click on pager
            var indexCurrent = slick.currentSlide;

            lazySlide(slides, indexCurrent);
        });

        if (video_wrap.length > 0) {
            video_wrap.find('.player_video').each(function () {
                var player_wrap = $(this);
                initVideoPlayer(player_wrap);
            });
        }

        wrap.find('.video_play').each(function () {
           var play_button = $(this);
           var counter = play_button.data('video-counter');
            play_button.click(function (e) {
                e.preventDefault();
                play_video(counter);
            });
        });
    }

}(jQuery) );
